import axiosInstance from '../config/axios.js';

const API_BASE = '/report';

const reportService = {
  // Download User Report
  downloadUserReport: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/user`, {
      params,
      responseType: 'blob',
    });
    _triggerDownload(response.data, `user_report_${_dateStamp()}.xlsx`);
    return response;
  },

  // Download Location Report
  downloadLocationReport: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/location`, {
      params,
      responseType: 'blob',
    });
    _triggerDownload(response.data, `location_report_${_dateStamp()}.xlsx`);
    return response;
  },

  // Download Vehicle Report
  downloadVehicleReport: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/vehicle`, {
      params,
      responseType: 'blob',
    });
    _triggerDownload(response.data, `vehicle_report_${_dateStamp()}.xlsx`);
    return response;
  },

  // Download ML Sheet Report
  downloadMLSheetReport: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/ml-sheet`, {
      params,
      responseType: 'blob',
    });
    _triggerDownload(response.data, `ml_sheet_report_${_dateStamp()}.xlsx`);
    return response;
  },

  // Download Shipment Report (includes Missing & Returned sheets)
  downloadShipmentReport: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/shipment`, {
      params,
      responseType: 'blob',
    });
    _triggerDownload(response.data, `shipment_report_${_dateStamp()}.xlsx`);
    return response;
  },

  // Download Expense Report
  downloadExpenseReport: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/expense`, {
      params,
      responseType: 'blob',
    });
    _triggerDownload(response.data, `expense_report_${_dateStamp()}.xlsx`);
    return response;
  },

  // Download Commission Report
  downloadCommissionReport: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/commission`, {
      params,
      responseType: 'blob',
    });
    _triggerDownload(response.data, `commission_report_${_dateStamp()}.xlsx`);
    return response;
  },

  // Download On-Contract Report
  downloadOnContractReport: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/on-contract`, {
      params,
      responseType: 'blob',
    });
    _triggerDownload(response.data, `on_contract_report_${_dateStamp()}.xlsx`);
    return response;
  },
};

// ── Helpers ────────────────────────────────────────────
function _dateStamp() {
  return new Date().toISOString().split('T')[0];
}

function _triggerDownload(blobData, filename) {
  const url = window.URL.createObjectURL(new Blob([blobData]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export default reportService;